/**
 * The shell around the swap terminal.
 *
 * There is no site navigation any more: this app is one flow plus the two
 * documents that flow points at, so a header full of links would be four
 * ways to leave the only page worth being on. The network notice stays at the
 * top because a wallet on the wrong chain has to be visible from anywhere.
 */
import { Route, Routes } from "react-router";

import { WalletNetworkNotice } from "@/components/ConnectButton";
import { ScrollReveal } from "@/components/ScrollReveal";
import { WalletProvider } from "@/components/WalletProvider";

import { ContractAddressesPage } from "@/routes/ContractAddressesPage";
import { NotFoundPage } from "@/routes/NotFoundPage";
import { SecurityPage } from "@/routes/SecurityPage";
import { SwapPage } from "@/routes/SwapPage";

export function App() {
  return (
    <WalletProvider>
      <ScrollReveal />
      <WalletNetworkNotice />
      <main className="site-main mx-auto flex-1 px-5 py-8 sm:px-8 sm:py-12 lg:px-10 lg:py-16">
        <Routes>
          <Route path="/" element={<SwapPage />} />
          {/* The old portal's migration lived at /claim and that link is out in
              the world — on BscScan, in chat groups — so it keeps working. */}
          <Route path="/claim" element={<SwapPage />} />
          <Route path="/contract-addresses" element={<ContractAddressesPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </WalletProvider>
  );
}
